import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthGuard } from './core/guards/auth.guard';

export const AppRoutes: Routes = [
  { 
    path: '', 
    redirectTo: '',
    component: ContentLayoutComponent,
    pathMatch: 'full'
  },
  { 
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: './modules/auth/auth.module#AuthModule'
    
  },
  {
    path: 'administration',
    component: AdminLayoutComponent,
    loadChildren: "./modules/administration/administration.module#AdministrationModule",
    canActivate: [AuthGuard]    
  },
  {
    path: 'application',
    component: AdminLayoutComponent,
    loadChildren: "./modules/application/application.module#ApplicationModule",
    canActivate: [AuthGuard]    
  },
  {
    path: 'users',
    component: AdminLayoutComponent,
    loadChildren: "./modules/users/users.module#UsersModule",
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot( AppRoutes )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
